<template>
    <div class="py-10 w-full px-6">
        <router-link :to="{ path: '/courses/' + course.id, params: { id: course.id } }">
            <div class="flex items-center">
                <div
                  class="mr-3 w-6 h-6 rounded-full text-gray-500 border border-gray-500 flex items-center justify-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-chevron-left"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <polyline points="15 6 9 12 15 18" />
                  </svg>
                </div>
                <div class="block">
                    <h4 class="text-xl text-gray-900">Zurück zum Kurs</h4>
                </div>
              </div>
        </router-link>
        <br>
        <section v-if="isInstructorsCourse" class="w-full px-6">
        <div class="block">
            <h1 class="title">Einladungen für <b-tag type="is-info" size="is-large">{{ course.name }}</b-tag> verwalten</h1>
        </div>
        <br>
        <!-- user for invite start-->
        <div 
        class="box"
        v-for="user in users"
        :key="user.id"
        >
          <article class="media">
            <!-- <div class="media-left">
              <figure class="image is-64x64">
                <img src="https://bulma.io/images/placeholders/128x128.png" alt="Image">
              </figure>
            </div> -->
            <div class="media-content">
              <div class="content">
                <p>
                  <strong>{{ user.email }}</strong>
                  
                  <b-tag rounded size="is-small" class="px-2 py-2 text-center mb-2 text-sm text-gray-600">
                    <small>{{ user.role.name }}</small>
                    </b-tag>
                    <b-tag v-show="user.confirmed" rounded size="is-small" type="is-success is-light" class="px-2 py-2 text-center mb-2 text-sm text-gray-600">
                    <small>Verifiziert</small>
                    </b-tag>
                    <b-tag v-show="user.blocked" rounded size="is-small" type="is-danger is-light" class="px-2 py-2 text-center mb-2 text-sm text-gray-600">
                    <small>Blockiert</small>
                    </b-tag>
                  <br>
                    {{ user.firstName }} in den Kurs <strong>{{course.name}}</strong> einladen.
                </p>
              </div>
              <nav class="level is-mobile">
                <div class="level-left">
                  <a class="level-item" aria-label="reply">
                    <b-tag v-show="course.courseProfession" rounded size="is-small" type="is-danger is-light" class="px-2 py-2 text-center mb-2 text-sm text-gray-600">
                    <small>{{ course.courseProfession }}</small>
                    </b-tag>
                    <span class="icon is-small">
                      <i class="fas fa-reply" aria-hidden="true"></i>
                    </span>
                  </a>
                  <a class="level-item" aria-label="retweet">
                    <span class="icon is-small">
                      <i class="fas fa-retweet" aria-hidden="true"></i>
                    </span>
                  </a>
                  <a class="level-item" aria-label="like">
                    <span class="icon is-small">
                      <i class="fas fa-heart" aria-hidden="true"></i>
                    </span>
                  </a>
                </div>
              </nav>
            </div>
          </article>
          <div>
            <div class="buttons">
              <b-button v-show="!course.users_permissions_users.some((p) => p.id === user.id)" @click="getUsers(user)" type="is-primary" expanded>Einladung versenden</b-button>
            </div>
              <div v-show="course.users_permissions_users.some((p) => p.id === user.id)" class="block">
                      <b-message type="is-success" has-icon>
                      Der Teilnehmer nimmt am Kurs teil.
                      </b-message>
                      <b-button @click="deleteInvite(user)" type="is-danger">Teilnehmer entfernen</b-button>
              </div>
              <font-awesome-icon
                v-if="course.isProtected"
                :icon="lockedIcon"
                color="red"
                class="mr-2"
                />
          </div>
      </div>
      <!-- user for invite end-->
        <br>
    
        <!-- INHALT FÜR WEITERE OPIONEN Wenn Instructor vom Kurs -->
    </section>
    <section v-else>
        <template>
            <div class="block">
            <section v-if="isActiveHintInvited">
                <b-message 
                    title="Hinweis!" 
                    type="is-success" 
                    has-icon
                    size="is-medium"
                    v-model="isActiveHintInvited" 
                    aria-close-label="Close message">
                    Du wurdest bereits zu diesem Kurs eingeladen!  
                    </b-message>
                    <b-message type="is-warning">
                        Der Autor kann dich aus dem Kurs wieder entfernen: {{ course.instructor.email }}
                    </b-message>
                    <!-- <b-button type="is-danger">Teilnahme entfernen</b-button> -->
            </section>
            <section v-else-if="!isActiveHint">
                <b-field label="Kurs">
                    <b-input name="subject" :value=course.name expanded disabled></b-input>
                </b-field>
                <b-field label="Von">
                    <b-input name="name" :value=user.username expanded disabled></b-input>
                    <b-input name="email" type="email" :value=user.email expanded disabled></b-input>
                </b-field>
                <b-field label="An">
                    <b-input name="instructor" :value=course.instructor.email expanded disabled></b-input>
                </b-field>

                <b-field label="Nachricht">
                    
                        <b-input placeholder="This is expanded" id="text" name="text" maxlength="200" type="textarea" value v-model="form.text"></b-input>
                
                </b-field>

                <b-field ><!-- Label left empty for spacing -->
                    <p class="control">
                        <b-button v-on:click=submitEmail label="Einladungsanfrage versenden" type="is-primary" />
                    </p>
                </b-field>
            </section>
            <section v-else>
            <b-message 
                title="Hinweis!" 
                type="is-success" 
                has-icon
                size="is-medium"
                v-model="isActiveHint" 
                aria-close-label="Close message">
                Du hast deine Anfrage zur Teilnahme mitgeteilt! Vielen Dank. Der Autor wird sich mit dir in Verbindung setzen. 
            </b-message>
            </section>
        </div>
</template>
    </section>
</div>
</template>

<script>
import gql from "graphql-tag";
import axios from 'axios'

import { ToastProgrammatic as Toast} from 'buefy';

import { mapState } from "vuex";

    export default {
        name: "Invite",
        data() {
        const data = [
            { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' },
            { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' },
            { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' },
            { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' },
            { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }
        ]
// checkedRows: [], ---> data[1], data[3]
            return {
                form: {
                to: "andre.bonne@googlemail.com",
                from: "demo@olymp.services",
                replyTo: "demo@olymp.services",
                subject: "eduBB Einladungsanfrage für den Kurs",
                text: "",
                html: "/invite/",
               },
               form2: {
                to: "andre.bonne@googlemail.com",
                from: "demo@olymp.services",
                replyTo: "demo@olymp.services",
                subject: "Du wurdest für den Kurs",
                text: "",
                html: "/course/",
               },
                user: JSON.parse(localStorage.getItem("user"))
                ? JSON.parse(localStorage.getItem("user"))
                : { role: { name: 0 } },
                API_URL:
                process.env.NODE_ENV == "production"
                    ? process.env.VUE_APP_STRAPI_API_URL
                    : "http://localhost:1338",
                FRONTEND_URL:
                process.env.NODE_ENV == "production"
                    ? "https://edubb.vercel.app"
                    : "http://localhost:1338",
                data,
                users:[],
                course: {},
                userInvited: '',
                userInvite: {},
                isActiveHintInvited: false,
                isActiveHint: false,
                inCourse: false,
                users_permissions_users: [],
                isUsersCourse: null,
                isInstructorsCourse: null,
                checkboxPosition: 'left',
                checkboxType: 'is-primary',
                checkedRows: [],
                isHoverable: true,
                columns: [
                    {
                        field: 'id',
                        label: 'ID',
                        width: '40',
                        numeric: true,
                    },
                    {
                        field: 'username',
                        label: 'Username',
                    },
                    {
                        field: 'firstName',
                        label: 'Vorname',
                    },
                    {
                        field: 'lastName',
                        label: 'Nachname',
                        searchable: true
                    },
                    {
                        field: 'email',
                        label: 'Email',
                        searchable: true
                    },
                    {
                        field: '',
                        label: 'Einladung',
                    },
                    {
                        field: 'rolle',
                        label: 'Institut',
                        centered: true
                    },
                    {
                        field: 'role.name',
                        label: 'Rolle',
                        centered: true,
                        searchable: true
                    }
                ]
            }
        },
        mounted(){
            console.log("user_permissions_users", this.course.users_permissions_users)
            //this.userId = this.$router.history.current.params.userId;
            this.courseId = this.$router.history.current.params.id;
            
            // console.log('routername', this.$router.history.current.path);
            // console.log('routername courseID', this.$router.history.current.params.id);
            // console.log('routername userId', this.$router.history.current.params.userId);
            
            this.userNotInCourseCheck()
        },
        updated(){
            //console.log("user_permissions_users", this.course.users_permissions_users)
        },
        methods:{

    async submitEmail(e){
        e.preventDefault()

        try{
            const to = this.form.to
            const from = this.form.from;
            const replyTo = this.form.from;
            const subject = this.form.subject + " " + this.course.name;
            const text = "Bitte die Einladung überprüfen und bestätigen! Vielen Dank!";
            // "Hallo " + this.userInvited + ",\n\n" + "du wurdest von " + this.user.name + " zu dem Kurs " + this.course.name + " eingeladen. \n\n" + "Bitte melde dich auf eduBB an und akzeptiere die Einladung. \n\n" + "Viele Grüße, \n" + this.user.username + "\n\n" + "eduBB Team"
            const html = text + ",\n\n" + this.FRONTEND_URL + this.form.html + this.course.id +"/"+this.user.id;

            const token = localStorage.getItem('token')
            ? localStorage.getItem('token')
            : null;

            const data = {
                to,
                from,
                replyTo,
                subject,
                text,
                html
            }

            await axios({
            method: 'POST',
            url: `${this.API_URL}` + '/email',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data
            }).then( (response) => {
            // Handle Success register email send
            console.log("response email reg",response)
            
            Toast.open({
                message: `Einladung erfolgreich versendet`,
                position: 'is-top',
                type: 'is-success is-light'
            })
            this.isActiveHint = true
            })
            }catch(err){
            this.error = true
            console.log("Email Exception", err)
            Toast.open({
                message: `Einladung konnte nicht versendet werden`,
                position: 'is-top',
                type: 'is-danger is-light'
            })
            this.isActiveHint = false
            }
        },

        async submitEmailInstructor(user){
       // e.preventDefault()

        try{
            const to = user.email
            const from = this.form2.from;
            const replyTo = this.form2.replyTo;
            const subject = "eduBB: " + this.form2.subject + " " + this.course.name + "eingeladen";
            const text = "Herzlichen Glückwunsch, du wurdest für den Kurs " + this.course.name + " eingeladen. Melde dich auf " + this.FRONTEND_URL + " an und du kannst den Kurs sofort nutzen. Viel Erfolg!";
            const html = text + ",\n\n" + this.FRONTEND_URL + this.form2.html + this.course.id;

            const token = localStorage.getItem('token')
            ? localStorage.getItem('token')
            : null;

            const data = {
                to,
                from,
                replyTo,
                subject,
                text,
                html
            }

            await axios({
            method: 'POST',
            url: `${this.API_URL}` + '/email',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data
            }).then( (response) => {
            // Handle Success register email send
            console.log("response email reg",response)
            
            Toast.open({
                message: `Einladung erfolgreich versendet`,
                position: 'is-top',
                type: 'is-success is-light'
            })
            
            })
            }catch(err){
            this.error = true
            console.log("Email Exception", err)
            Toast.open({
                message: `Einladung konnte nicht versendet werden`,
                position: 'is-top',
                type: 'is-danger is-light'
            })

            }
        },

        async getUsers(user){
            try{
                const token = localStorage.getItem('token')
                ? localStorage.getItem('token')
                : null;

                await axios({
                    method: 'GET',
                    url: `${this.API_URL}` + '/users/'+user.id,
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }).then( (response) => {
                    // Handle Success register email send
                    console.log("response getUsers",response)
                    this.user = response.data
                    }).then( () => {
                        this.userInvite = user
                        console.log("response getUsers",user)
                    }).then( () => {
                        this.userNotInCourse()
                        this.saveChanges()
                    }).then( () => {
                        console.log("EMail senden an", user)
                        this.submitEmailInstructor(user)
                        //location.reload(this.$router.currentRoute)
                    })
              //  console.log('get Users response', response)
                // this.users = response.data
                // this.userInvite = response.data
                // console.log('getUsers fetch api', this.users)
            }catch(err){
                console.log('getUsers Exception', err)
            }
        },

        async getCourse(){
            try{
                const token = localStorage.getItem('token')
                ? localStorage.getItem('token')
                : null;

                await axios({
                    method: 'GET',
                    url: `${this.API_URL}` + '/courses/'+ this.courseId,
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }).then( (response) => {
                    // Handle Success register email send
                    console.log("response getCourse",response)
                    this.course = response.data
                    console.log("response getCourse",this.course)
                    })
            }catch(err){
                console.log('getCourse Exception', err)
            }
        },

            setIsUsersCourse() {
            try{
            console.log("setUsersCourse Method", this.usersCourses)
            this.userIsNotInCourse()
            if (this.usersCourses) {
                console.log(
                "course data available, figuring out if this course is users course"
                );
            // console.log("course id", this.course.id);
                
                const usersCourse = this.usersCourses.find((userCourse) => {
                return userCourse.id == this.course.id;
                });

            //const usersCourse = this.course.id;
            // console.log("users Course", usersCourse)
                this.isUsersCourse = usersCourse ? true : false;

                if (usersCourse && this.user.role.name == 2)
                this.isInstructorsCourse = true;
                else this.isInstructorsCourse = false;

                // console.log("is Police course:", this.isPolizeiCourse);
                // console.log("is Feuerwehr course:", this.isFeuerwehrCourse);

                // console.log("is users course:", this.isUsersCourse);
                 console.log("user is instructor:", this.isInstructorsCourse);
                // console.log("modules", this.modules);
            }
            }catch(error){
                console.log("Error setIsUsersCourse CourseDetails", error)
            }
            },

     async saveChanges() {
      //e.preventDefault()
      try{
       // this.countlicence()
        console.log("updated course", this.course);
        // Toast.open({
        //     message: `Der Kurs wurde erfolgreich geändert!`,
        //     duration: 8000,
        //     progressBar: true,
        //     position: 'is-top-center',
        //     type: 'is-success',
        //     pauseOnHover: true
        //  })
        this.$store.dispatch("update", this.course);
       // location.reload(this.$router.currentRoute)
        //this.$router.go(-1);
      }catch(error){
        console.log("error saveChanges courseDetails",error)
      }
    },
            // Altes modulesNotInSection 
     userNotInCourse() {
      try{
      let usersInCourse = this.course.users_permissions_users;
      //console.log("usersInCourse", usersInCourse)
      //let usersNotInCourse = [];
      
      this.inCourse = false;
      
      for (let i = 0; i <= usersInCourse.length; i++) {
          
          console.log("userInvite", this.userInvite)
          console.log("userInvite id", this.userInvite.id)
          this.inCourse = false;

          for (let j = 0; j < usersInCourse.length; j++) {
         //   console.log("usersInCourse", usersInCourse[j])
            const userInCourse = usersInCourse[j];
         //   console.log("userInCourse email", userInCourse.email)
         //   console.log("userInvite email", userInvite.email)
            if (userInCourse.email === this.userInvite.email){
                this.inCourse = true;
           //     console.log("inCourse", this.inCourse)
            } 
          }
          if (!this.inCourse){
           // console.log("usersNotInCourse", userInvite)
            //usersNotInCourse.push(userInvite);
            this.course.users_permissions_users.push(this.userInvite);
            console.log("course", this.course)
            }
            if(this.inCourse){
                console.log("inCourse bereits durchgeführt", this.inCourse)
                return this.inCourse;
            }
        }
       // console.log("course", this.course)
        //this.$store.dispatch("update", this.courseInvite);
           // return usersInCourse;
        }catch(error){
            console.log("Error userNotInCourse CourseDetails", error)
        }
    }, 

    userNotInCourseCheck() {
      try{
      let usersInCourse = this.course.users_permissions_users;
      console.log("usersInCourse", usersInCourse)
      
      //let usersNotInCourse = [];
      
      this.inCourse = false;
      
      for (let i = 0; i <= usersInCourse.length; i++) {
          const userInvite = this.userInvite;
          console.log("userInvite", userInvite.email)
          this.inCourse = false;

          for (let j = 0; j < usersInCourse.length; j++) {
         //   console.log("usersInCourse", usersInCourse[j])
            const userInCourse = usersInCourse[j];
         //   console.log("userInCourse email", userInCourse.email)
         //   console.log("userInvite email", userInvite.email)
            if (userInCourse.email === userInvite.email){
                this.inCourse = true;
           //     console.log("inCourse", this.inCourse)
            } 
          }
          if (!this.inCourse){
           // console.log("usersNotInCourse", userInvite)
            //usersNotInCourse.push(userInvite);
            //this.course.users_permissions_users.push(userInvite);
          
            }
            if(this.inCourse){
                console.log("inCourse bereits durchgeführt", this.inCourse)
               
                return this.inCourse;
            }
        }
      //  console.log("course", this.course)
        console.log("user is in course", this.inCourse)
        //this.$store.dispatch("update", this.courseInvite);
           // return usersInCourse;
        }catch(error){
            console.log("Error userNotInCourse CourseDetails", error)
        }
    }, 

    deleteInvite(user) {
      try{
      var sectionId = 0
      var modId = 0
      let usersInCourse = this.course.users_permissions_users;
      console.log("usersInCourse", usersInCourse)
      //let usersNotInCourse = [];
      
      this.inCourse = false;
      
      for (let i = 0; i <= usersInCourse.length; i++) {
          const userInvite = user;
          console.log("userInvite", userInvite.email)
          this.inCourse = false;

          for (let j = 0; j < usersInCourse.length; j++) {
         //   console.log("usersInCourse", usersInCourse[j])
            const userInCourse = usersInCourse[j];
            modId = usersInCourse[j]
         //   console.log("userInvite email", userInvite.email)
            if (userInCourse.email === userInvite.email){
                this.inCourse = true;
                sectionId = j
                console.log("sectionId", sectionId)
                console.log("modId", modId)
               // console.log("this.course.users_permissions_users", this.course.users_permissions_users.splice(sectionId,1))
                this.course.users_permissions_users.splice(sectionId,1)
                this.saveChanges()
               // this.course.users_permissions_users.userInvite.splice(modId,1)
           //     console.log("inCourse", this.inCourse)
            } 
          }
          if (!this.inCourse){
           // console.log("usersNotInCourse", userInvite)
            //usersNotInCourse.push(userInvite);
            //this.course.users_permissions_users.push(userInvite);
          
            }
            if(this.inCourse){
                console.log("inCourse bereits durchgeführt", this.inCourse)
                console.log("this course", this.course)
                //this.course.users_permissions_users[sectionId].modules.splice(modId,1)
                return this.inCourse;
            }
        }
      //  console.log("course", this.course)
        console.log("user is in course", this.inCourse)
        //this.$store.dispatch("update", this.courseInvite);
           // return usersInCourse;
        }catch(error){
            console.log("Error userNotInCourse CourseDetails", error)
        }
    }, 
/*             userIsInCourse(userIndex) {
                let userIsInCourse = this.course.users_permissions_users[userIndex].email;
                let modulesNotInSection = [];

                console.log("modulesInCourse", JSON.stringify(userIsInCourse))
                console.log("module length", this.modules.length)

                let inUser = false;
                for (let i = 0; i < this.modules.length; i++) {
                    const mod = this.modules[i];
                    inUser = false;

                
                    if (!inUser || !mod.name) modulesNotInSection.push(mod);
                }

                return modulesNotInSection;
            }, */
            userIsNotInCourse() {
                //console.log("user_permissions_users", this.course.users_permissions_users.some((p) => p.email === this.user.email))
              //  console.log("users", this.users)
            if (this.course.users_permissions_users.some((p) => p.email === this.user.email)) {
                this.userInvited = true
                this.isActiveHintInvited = true
                console.log("user invited:", this.userInvited)
            }
            },
        },
        computed: {
            ...mapState({
            // users_permissions_users: "users_permissions_users",
            //usersInvite: "usersInvite",
            usersCourses: "usersCourses",
            }),
            didLoad: function () {
            // this is just a bool to load the data setting methods when page is called. ignore its value.
            console.log("loading page...");
            if (this.course === null){
                console.log("Kurs ist NULL")
                this.setCourseData();
            } 
            if (this.isUsersCourse === null){
                console.log("UserCourse ist Null")
                this.setIsUsersCourse();
            } 
              console.log("course", this.course);
            return true;
            },
        },
    apollo: {
        course: {
            query: gql`
                query ($id: ID!) {
                    course(id: $id) {
            id
            name
            description
            duration
            isPublic
            isInvite
            isInviteCourse
            isProtected
            isDraft
            noLicence
            courseProfession
            users_permissions_users{
            id
            username
            email
            }
            course_category {
              id
              name
            }
            skill {
              id
              name
            }
            instructor {
                id
                firstName
                lastName
                email
                profession
              }
            sections {
              id
              name
              description
              modules {
                id
                name
                description
                licence
                CC
                module_subcategory
                media {
                  id
                  name
                  mime
                  url
                }
              }
            }
            instructor {
              id
            }
          }
            }
            `,
            variables() {
                return {
                id: this.$route.params.id,
                };
            },
            },
        users: {
        query: gql`
        query {
        users {
            id
            username
            firstName
            lastName
            email
            confirmed
            blocked
            rolle
            profession
            role{
                name
            }
          }
        }
        `,
        },
/*         query: qql` {
        users(where: {
    email_contains: "@olymp.services"
  					}) {
            id
            username
            firstName
            lastName
            email
            confirmed
            rolle
          }
        }
        `
        , */
/*         users_permissions_users: {
            query: gql`
                query {
                    users_permissions_users {
                    id
                    name
                    email
                }
                }
            `,
            },  */
    },
    watch: {
    dataToBeWatched: function(val){
      if(val){
        console.log("something chaged")
      }
    },
    course: function () {
      try{
        console.log("users course",this.course)
        this.setIsUsersCourse();
      }catch(e){
        console.log("error course function watch")
      }
    },
    users_permissions_users: function(){
        try{
        this.userIsNotInCourse();
      }catch(e){
        console.log("error userIsInCourse function watch",e)
      }
    },
    usersCourses: function () {
      try{
        this.setIsUsersCourse();
      }catch(e){
        console.log("error usersCourses function watch", e)
      }
    },
    usersInvite: function(){
        try{
            this.userIsNotInCourse();
        }catch(err){
            console.log("usersInvite error", err)
        }
    }
  },
}
</script>

<!-- 
  the recommended way to get $route instance in setup is

import { useRoute } from 'vue-router/composables'  // need vue-router v3.6
export default{
  setup(){
    const route = useRoute()
  }
} -->